import React, { Component } from 'react';
import Tile from '../components/tile';
import Video from '../components/video';
import rulingMachine from '../videos/ruling-machine.mp4';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playVideo: false,
      videoId: '',
      videoUrl: '',
      images: [
         {
           url:  'scroll-image.jpg',
           prevText: "",
           video: 'handpress',
           subtitles:  undefined,
           subtitlesIrish:  undefined,
           nextText: "Next Printer"
         },
         {
          url:  'scroll-image.jpg',
          video: 'freddySnowHandpress',
          subtitlesIrish: 'captions_Irish_Peerless.vtt',
          subtitles: 'captions_Peerless.vtt',
          prevText: "Previous Printer",
          nextText: "Next Printer"
        },
        {
          video: 'freddie-snow-wharf',
          subtitlesIrish: 'captions_Irish_Wharfdale.vtt',
          subtitles: 'captions_Wharfdale.vtt',
          url:  'scroll-image.jpg',
          prevText: "Previous Printer",
          nextText: ""
        }
      ],
      mediaIndex: 0
    };
  }

  playVideo(index) {
    this.setState({ playVideo: true, mediaIndex:  index });
    var elem = document.body;

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
      document.body.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE/Edge */
      elem.msRequestFullscreen();
    }
  }

  closeVideo() {
    this.setState({ playVideo: false, mediaIndex: 0 });
  }

  nextVideo() {
   if( this.state.mediaIndex < this.state.images.length -1 )
   {
    this.setState({mediaIndex: this.state.mediaIndex + 1})

   }

   else{
    this.setState({ playVideo: false, mediaIndex: 0 });
  }
  }

  prevVideo() {
    if( this.state.mediaIndex > 0 ){
    this.setState({mediaIndex: this.state.mediaIndex - 1})

    }
    else{
      this.setState({ playVideo: false });
    }

    
  }

  render() {
    const mediaIndex = this.state.mediaIndex;
    console.log(mediaIndex);
    const text =
      'The Wharfedale became one of the leading production presses of its time, producing up to 800 copies per hour. The Irish Proclamation 1916 was printed on a machine similar to this. In commemoration of the 1916 Rising, replica copies of the country’s most historic document have been reproduced on this machine and are available for sale in the gift shop and online.';
    return (
      <div style={{  background: 'red'}} className="home">
        {this.state.playVideo ? (
          <Video
            onClose={() => this.closeVideo()}
            onNext={() => this.nextVideo() }
            subtitles={this.state.images[mediaIndex].subtitles}
            subtitlesIrish={this.state.images[mediaIndex].subtitlesIrish}
            onPrev={() => this.prevVideo()}
            playNext={() => this.nextVideo()}
            videoUrl={this.state.images[mediaIndex].video}
            imageUrl={this.state.images[mediaIndex].url}
            nextText={this.state.images[mediaIndex].nextText}
            noLast={this.state.mediaIndex === this.state.images.length -1}
            noFirst={this.state.mediaIndex === 0}
            prevText={this.state.images[mediaIndex].prevText}
          />
        ) : (
          <div  style={{flex: 1}}>
            <Tile
              bg={'typewriter.png'}
              onPlay={(index) => this.playVideo(index)}
              title={'Peerless Platen'}
              subTitle={
                '— Freddie Snowe'
              }
              bold={'Printer'}
              text={'Treadle platens were printing presses operated by foot. They were ideal for jobbing work, such as small and quick jobs like leaflets or flyers, because of their compact size and ease of use'}
            />
            <Tile
              onPlay={(videoId) => this.playVideo(videoId)}
              bg={'scroll-image.jpg'}
              type="wharf"
              title={'wharfedale stop cylinder press '}
              subTitle={'— Freddie Snowe'}
              bold={'Printer'}
              text={text}
            />
          </div>
        )}
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home.js